<script lang="ts">
    import { appManager } from "../../AppManager";
	import { _ } from "svelte-i18n";
    import type { ModelInfoManager } from "./ModelInfoManager";
    import TitledControl from "../../components/map/controls/TitledControl.svelte";
    import Fod2017ModelInfo from "./fod_2017/Fod2017ModelInfo.svelte";
    import SafeToSchoolModelInfo from "./safe_to_school/SafeToSchoolModelInfo.svelte";
    import DefaultModelInfo from "./DefaultModelInfo.svelte";

    export let manager: ModelInfoManager;
    let collapsedStore = manager.getCollapsedStore();
    let modelTranslationKeyStore = manager.getModelTranslationKeyStore();
    let selectedLocationStore = manager.getSelectedLocationStore();
    let selectedSegmentStore = manager.getSelectedSegmentStore();

    let isSmall: boolean = false;
    appManager.isSmall.subscribe(v => {
        isSmall = v;
    });

    const infoShown = () => {
        window.localStorage.setItem("infoShown", "true");
        $collapsedStore=true;
    };
</script>

{#if typeof $selectedLocationStore === "undefined" && typeof $selectedSegmentStore === "undefined"}
<TitledControl
    class="model-info-control bg-white" {manager}>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <h5 slot="title" class="mb-0" on:click={() => manager.onToggleCollapsed()}><button class="border-0 bg-transparent fe fe-info me-2"></button><strong>{$_(`${$modelTranslationKeyStore}.info.title`)}</strong></h5>
    <div slot="content-collapsed" class="d-flex flex-column justify-content-center align-items-center">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <button on:click={() => manager.onToggleCollapsed()} class="border-0 bg-transparent icon-collapsed">
            <i class="fe fe-info"></i>
        </button>
    </div>

    <div slot="content" class="card" style="width: 100%;">
        {#if $modelTranslationKeyStore === "fod_2017"}
            <Fod2017ModelInfo {manager} />
        {:else if $modelTranslationKeyStore === "safe_to_school"}
            <SafeToSchoolModelInfo {manager} />
        {:else}
            <DefaultModelInfo {manager} />
        {/if}
    </div>
</TitledControl>
{/if}